export const formatterForOption = (element: any, key: string, key2?: string) => ({
  value: element[key2 || key],
  label: element[key],
});

export const formatterForOptions = (arr: any[], key: string, key2?: string) => arr.map((item: any) => formatterForOption(item, key, key2));
